import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useHover, useActive } from 'react-native-web-hooks';
import styled from 'styled-components/native';
import Colors from '../colors';
import Icon from '../icon';
const StyledPressable = styled.Pressable`
  justify-content: center;
`;
const Types = ['secondary', 'tertiary'];
const color = {
  secondary: {
    text: Colors.mint400,
    hoverText: Colors.white,
    hoverBackgroundColor: Colors.mint400,
    hoverBorderColor: Colors.mint400,
    activeText: Colors.white,
    activeBackgroundColor: Colors.mint500,
    activeBorderColor: Colors.mint500,
    icon: Colors.mint400,
    iconHover: Colors.white
  },
  tertiary: {
    text: Colors.mint500,
    hoverText: Colors.mint500,
    hoverBackgroundColor: Colors.lightGray200,
    hoverBorderColor: Colors.lightGray200,
    activeText: Colors.mint500,
    activeBackgroundColor: Colors.lightGray300,
    activeBorderColor: Colors.lightGray300,
    icon: Colors.mint400,
    iconHover: Colors.mint400
  }
};
export default function IconBtn(props) {
  const type = Types.includes(props.type) ? props.type : IconBtn.defaultProps.type;
  const ref = useRef();
  const isHovered = useHover(ref);
  const isActive = useActive(ref);
  const StyledIcon = props.iconFamily;
  const hoverStyle = {
    color: color[type].hoverText,
    backgroundColor: color[type].hoverBackgroundColor,
    borderColor: color[type].hoverBorderColor
  };
  const activeStyle = {
    color: color[type].activeText,
    backgroundColor: color[type].activeBackgroundColor,
    borderColor: color[type].activeBorderColor
  };
  return /*#__PURE__*/React.createElement(StyledPressable, {
    style: [styles.button, styles[type], isHovered && !props.disabled && hoverStyle, isActive && !props.disabled && activeStyle, props.disabled && styles.disabled],
    ref: ref,
    disabled: props.disabled,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    color: isHovered && !props.disabled ? color[type].iconHover : color[type].icon,
    name: props.icon,
    size: 24
  }));
}
IconBtn.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  iconFamily: PropTypes.elementType,
  disabled: PropTypes.bool,
  onPress: PropTypes.func
};
IconBtn.defaultProps = {
  icon: '',
  iconFamily: Icon.MaterialIcons,
  type: 'secondary',
  disabled: false,
  onPress: () => {}
};
const styles = {
  button: {
    borderRadius: 100,
    overflow: 'hidden',
    height: 40,
    width: 40,
    borderWidth: 2,
    justifyContent: 'center',
    alignItems: 'center'
  },
  secondary: {
    backgroundColor: Colors.white,
    borderColor: Colors.mint400
  },
  tertiary: {
    backgroundColor: Colors.transparent,
    borderColor: Colors.transparent
  },
  disabled: {
    opacity: 0.4
  }
};
//# sourceMappingURL=icon.js.map